/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface User { 
    id?: number;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    roleName?: string;
    companyId: number;
    companyName?: string;
    password?: string;
    isAccountNonExpired?: boolean;
    isAccountNonLocked?: boolean;
    isCredentialsNonExpired?: boolean;
    isEnabled?: boolean;
    startPage?: string;
}

